// Migrated from transition-web/src/components/SignedInOnboarding.tsx
// Updated to use new design system

import { useNavigate } from 'react-router-dom'
// import { useTranslation } from '../shared/hooks/useIntractionTranslate' // TODO: Re-enable when translations are added
import { SignedInViewProps } from '../types/SignedInTypes'
import { BackgroundBox, Button, InnerBox } from '../interaxDesignSystemComponents'
import { useLogout } from '../hooks/useLogout'

export default function SignedInOnboarding({ isLoading, signedInState, onPressContinue }: SignedInViewProps) {
  const navigate = useNavigate()
  const logout = useLogout(() => navigate('/'))
  // const { t } = useTranslation() // TODO: Add translations when needed

  const handleContinue = () => {
    onPressContinue(signedInState)
  }

  return (
    <div className="min-h-screen bg-off-black flex items-center justify-center p-4">
      <div className="max-w-md w-full space-y-8">
        <BackgroundBox>
          <div className="flex justify-between items-center mb-8">
            <div></div>
            <Button variant="link" onClick={logout} className="text-thunder-grey hover:text-white">
              Sign Out
            </Button>
          </div>

          <InnerBox>
            {/* Header */}
            <div className="text-center">
              <div className="mb-8">
                {/* TODO: Add Interax logo component */}
                <div className="w-16 h-16 bg-sun rounded-full mx-auto mb-4"></div>
              </div>
              <h1 className="text-3xl font-semibold text-white mb-2">Welcome to Interax!</h1>
              <p className="text-thunder-grey">Let's get you started with a quick introduction to the platform.</p>
            </div>

            {/* Onboarding Content */}
            <div className="bg-heritage-blue/10 border border-heritage-blue/20 rounded-lg p-6">
              <h2 className="text-xl font-semibold text-white mb-4">Getting Started</h2>
              <div className="space-y-4 text-thunder-grey">
                <p>
                  Welcome to Interax! This platform helps teams collaborate more effectively through interactive
                  experiences and data-driven insights.
                </p>
                <p>
                  You'll be able to participate in team activities, track your progress, and gain valuable insights
                  about your collaboration style.
                </p>
              </div>
            </div>

            {/* Continue Button */}
            <Button variant="primary" fullWidth onClick={handleContinue} disabled={isLoading} className="h-12">
              {isLoading ? 'Loading...' : 'Start Introduction'}
            </Button>
          </InnerBox>
        </BackgroundBox>
      </div>
    </div>
  )
}
